import React, { useContext } from "react";
import { AppContext } from "~context/AppContext";
import Newsletter from "~components/Newsletter";
import ScreenHeight from "~components/ScreenHeight";

const NewsletterModal = () => {
  const { newsletterModalActive, setNewsletterModalActive } = useContext(
    AppContext
  );

  //

  return (
    <ScreenHeight className="w-screen fixed top-0 right-0 bottom-0 left-0 z-40 flex items-center justify-center pointer-events-none">
      <div
        role="presentation"
        className={`${
          newsletterModalActive
            ? `opacity-25 pointer-events-auto`
            : `opacity-0 pointer-events-none`
        } transition-opacity w-full h-full absolute top-0 right-0 bottom-0 left-0 bg-black cursor-pointer`}
        onClick={() => setNewsletterModalActive(false)}
      ></div>

      <div
        className={`newsletter-modal ${
          newsletterModalActive ? `active` : ``
        } relative pointer-events-none`}
      >
        <Newsletter modal />
      </div>
    </ScreenHeight>
  );
};

export default NewsletterModal;
